<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        {{ "control_gallery_settings" | translate }}
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            @if (galleryType === EGalleryTypes.carousel || galleryType === EGalleryTypes.collage) {
                <div
                    class="form-group"
                    [ngClass]="{
                        'mb-0': galleryType === EGalleryTypes.carousel && type?.value === 'thumbs-gallery',
                        'mb-20': !(galleryType === EGalleryTypes.carousel && type?.value === 'thumbs-gallery'),
                    }"
                >
                    <label class="col-xs-12">{{ "gallery_appearance" | translate }}</label>
                    <div class="col-xs-12">
                        @if (galleryType === EGalleryTypes.carousel) {
                            <div class="appearance-wrapper">
                                @for (variant of APPEARANCE_VARIANTS.carouselAppearance; track variant) {
                                    <div
                                        (click)="setType(variant)"
                                        [ngClass]="{ active: type.value === variant }"
                                        class="appearance-block carousel"
                                    >
                                        <img
                                            src="./assets/img/websites/gallery-variants/lpc-carousel-{{ variant }}.svg"
                                        />
                                    </div>
                                }
                            </div>
                        }

                        @if (galleryType === EGalleryTypes.collage) {
                            <div class="appearance-wrapper">
                                @for (variant of APPEARANCE_VARIANTS.collageAppearance; track variant) {
                                    <div
                                        class="appearance-block collage"
                                        [ngClass]="{ active: style.value === variant }"
                                        (click)="setCollageStyle(variant)"
                                    >
                                        <img
                                            src="./assets/img/websites/gallery-variants/lpc-collage-{{ variant }}.svg"
                                        />
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            @if (galleryType === EGalleryTypes.carousel && type?.value === "thumbs-gallery") {
                <div class="form-group mb-20">
                    <div class="col-xs-12">
                        <label class="checkbox-inline">
                            <input type="checkbox" [formControl]="isShowLastPreviewEdge" />
                            {{ "control_show_last_preview_edge" | translate }}
                        </label>
                    </div>
                </div>
            }
            <div class="form-group mb-10">
                <div class="col-xs-12">
                    <div class="mb-10 device-toggle-wrapper">
                        <web-device-toggle></web-device-toggle>

                        <web-synchronize-style-toggle
                            [active]="isSynchronizeStyle"
                            (click)="onSynchronizeStyleToggle()"
                        ></web-synchronize-style-toggle>
                    </div>

                    @if (isDeviceDesktop$ | async) {
                        <p class="help-block text-muted small">
                            {{ "desktop_device_hint" | translate }}
                        </p>
                    }

                    @if (isDeviceTablet$ | async) {
                        <p class="help-block text-muted small">
                            {{ "tablet_device_hint" | translate }}
                        </p>
                    }

                    @if (isDeviceMobile$ | async) {
                        <p class="help-block text-muted small">
                            {{ "mobile_zero_device_hint" | translate }}
                        </p>
                    }
                </div>
            </div>

            @if (isSynchronizeStyle) {
                <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
            } @else {
                @if (isDeviceDesktop$ | async) {
                    <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
                }
                @if (isDeviceTablet$ | async) {
                    <ng-container *ngTemplateOutlet="tabletSettings"> </ng-container>
                }
                @if (isDeviceMobile$ | async) {
                    <ng-container *ngTemplateOutlet="mobileSettings"> </ng-container>
                }
            }

            <ng-template #desktopSettings>
                @if (galleryType !== EGalleryTypes.collage) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">{{ "gallery_row_items" | translate }}</label>
                        <div class="col-xs-12">
                            <div class="btn-group d-flex">
                                @for (num of MAX_IMAGE_IN_ROW; track num) {
                                    <button
                                        [ngClass]="{ active: rowItems.value === num }"
                                        (click)="setRowItems(num)"
                                        class="btn btn-grey w-100"
                                        [class.disabled]="disabledRowItemsNumber(num)"
                                    >
                                        {{ num }}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">{{ "gallery_gap" | translate }}</label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/websites/lpc-indent-between-icon.svg"
                            suffixText="px"
                            [min]="0"
                            [max]="50"
                            [value]="imageGap.value"
                            (valueChange)="setImageGap($event)"
                        >
                        </sp-input-num>
                    </div>
                </div>

                @if (galleryType === EGalleryTypes.carousel) {
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">{{ "gallery_arrow_size" | translate }}</label>
                        <div class="col-xs-6">
                            <sp-input-num
                                suffixText="px"
                                [min]="ARROW_SIZE_MIN"
                                [max]="ARROW_SIZE_MAX"
                                [value]="arrowSize.value"
                                (valueChange)="setArrowSize($event)"
                            >
                            </sp-input-num>
                        </div>
                    </div>
                }

                @if (galleryType === EGalleryTypes.carousel && type?.value === "thumbs-gallery") {
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">{{ "gallery_preview_height" | translate }}</label>
                        <div class="col-xs-6">
                            <sp-input-num
                                suffixText="px"
                                [min]="PREVIEW_HEIGHT_MIN"
                                [max]="PREVIEW_HEIGHT_MAX"
                                [value]="previewImageHeight.value"
                                (valueChange)="setPreviewImageHeight($event)"
                            >
                            </sp-input-num>
                        </div>
                    </div>
                }
            </ng-template>

            <ng-template #tabletSettings>
                @if (galleryType !== EGalleryTypes.collage) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">{{ "gallery_row_items" | translate }}</label>
                        <div class="col-xs-12">
                            <div class="btn-group d-flex">
                                @for (num of MAX_IMAGE_IN_ROW; track num) {
                                    <button
                                        [ngClass]="{ active: rowItemsTablet.value === num }"
                                        (click)="setRowItemsTablet(num)"
                                        class="btn btn-grey w-100"
                                        [class.disabled]="disabledRowItemsNumber(num)"
                                    >
                                        {{ num }}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">{{ "gallery_gap" | translate }}</label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/websites/lpc-indent-between-icon.svg"
                            suffixText="px"
                            [min]="0"
                            [max]="50"
                            [value]="imageGapTablet.value"
                            (valueChange)="setImageGapTablet($event)"
                        >
                        </sp-input-num>
                    </div>
                </div>

                @if (galleryType === EGalleryTypes.carousel) {
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">{{ "gallery_arrow_size" | translate }}</label>
                        <div class="col-xs-6">
                            <sp-input-num
                                suffixText="px"
                                [min]="ARROW_SIZE_MIN"
                                [max]="ARROW_SIZE_MAX"
                                [value]="arrowSizeTablet.value"
                                (valueChange)="setArrowSizeTablet($event)"
                            >
                            </sp-input-num>
                        </div>
                    </div>
                }

                @if (galleryType === EGalleryTypes.carousel && type?.value === "thumbs-gallery") {
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">{{ "gallery_preview_height" | translate }}</label>
                        <div class="col-xs-6">
                            <sp-input-num
                                suffixText="px"
                                [min]="PREVIEW_HEIGHT_MIN"
                                [max]="PREVIEW_HEIGHT_MAX"
                                [value]="previewImageHeightTablet.value"
                                (valueChange)="setPreviewImageHeightTablet($event)"
                            >
                            </sp-input-num>
                        </div>
                    </div>
                }
            </ng-template>

            <ng-template #mobileSettings>
                @if (galleryType !== EGalleryTypes.collage) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">{{ "gallery_row_items" | translate }}</label>
                        <div class="col-xs-12">
                            <div class="btn-group d-flex">
                                @for (num of MAX_IMAGE_IN_ROW; track num) {
                                    <button
                                        [ngClass]="{ active: rowItemsMobile.value === num }"
                                        (click)="setRowItemMobile(num)"
                                        class="btn btn-grey w-100"
                                        [class.disabled]="disabledRowItemsNumber(num)"
                                    >
                                        {{ num }}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">{{ "gallery_gap" | translate }}</label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/websites/lpc-indent-between-icon.svg"
                            suffixText="px"
                            [min]="0"
                            [max]="50"
                            [value]="imageGapMobile.value"
                            (valueChange)="setImageGapMobile($event)"
                        >
                        </sp-input-num>
                    </div>
                </div>

                @if (galleryType === EGalleryTypes.carousel) {
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">{{ "gallery_arrow_size" | translate }}</label>
                        <div class="col-xs-6">
                            <sp-input-num
                                suffixText="px"
                                [min]="ARROW_SIZE_MIN"
                                [max]="ARROW_SIZE_MAX"
                                [value]="arrowSizeMobile.value"
                                (valueChange)="setArrowSizeMobile($event)"
                            >
                            </sp-input-num>
                        </div>
                    </div>
                }

                @if (galleryType === EGalleryTypes.carousel && type?.value === "thumbs-gallery") {
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">{{ "gallery_preview_height" | translate }}</label>
                        <div class="col-xs-6">
                            <sp-input-num
                                suffixText="px"
                                [min]="PREVIEW_HEIGHT_MIN"
                                [max]="PREVIEW_HEIGHT_MAX"
                                [value]="previewImageHeightMobile.value"
                                (valueChange)="setPreviewImageHeightMobile($event)"
                            >
                            </sp-input-num>
                        </div>
                    </div>
                }
            </ng-template>

            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <hr class="panel-options-divider" />
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "widget_product_settings_attachment_label" | translate }}</label>
                <div class="col-xs-12">
                    <select class="form-control" [formControl]="attachment">
                        @for (option of attachmentOptions; track option) {
                            <option [selected]="attachment.value === option" [value]="option">
                                {{ option | translate }}
                            </option>
                        }
                    </select>
                </div>
            </div>

            @if (galleryType === EGalleryTypes.carousel && type?.value === "thumbs-gallery") {
                <div class="form-group mb-20">
                    <label class="col-xs-12">{{
                        "widget_product_settings_attachment_preview_label" | translate
                    }}</label>
                    <div class="col-xs-12">
                        <select class="form-control" [formControl]="previewAttachment">
                            @for (option of attachmentOptions; track option) {
                                <option [selected]="previewAttachment.value === option" [value]="option">
                                    {{ option | translate }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            }

            <div class="form-group mb-20">
                <label class="col-xs-10 control-label">{{ "control_background_color" | translate }}</label>
                <div class="col-xs-2">
                    <sp-color-picker
                        [color]="backgroundColor.value"
                        [colorsPreset]="selectedThemeColors()"
                        [hideGradient]="true"
                        (colorChangeEvent)="setBackgroundColor($event)"
                    >
                    </sp-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-6 control-label"> {{ "control_radius" | translate }}</label>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/websites/lpc-corner-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="borderRadius.value"
                        (valueChange)="setBorderRadius($event)"
                    >
                    </sp-input-num>
                </div>
            </div>

            @if (galleryType === EGalleryTypes.carousel) {
                <div class="form-group mb-20">
                    <label class="col-xs-10 control-label">{{ "gallery_knobs_colors" | translate }}</label>
                    <div class="col-xs-2">
                        <sp-color-picker
                            [color]="knobsColor.value"
                            [colorsPreset]="selectedThemeColors()"
                            [hideGradient]="true"
                            (colorChangeEvent)="setKnobsColor($event)"
                        >
                        </sp-color-picker>
                    </div>
                </div>
            }

            @if (galleryType === EGalleryTypes.carousel && type?.value !== "thumbs-gallery") {
                <div class="form-group mb-20">
                    <label class="col-xs-10 control-label">{{ "gallery_dots_colors" | translate }}</label>
                    <div class="col-xs-2">
                        <sp-color-picker
                            [color]="dotsColor.value"
                            [colorsPreset]="selectedThemeColors()"
                            [hideGradient]="true"
                            (colorChangeEvent)="setDotsColor($event)"
                        >
                        </sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">{{ "gallery_arrow_outside_container" | translate }}</label>
                    <div class="col-xs-3 text-right">
                        <sp-switch [control]="isOutsideContainerArrow"></sp-switch>
                    </div>
                </div>
            }

            <div [ngClass]="{ 'mb-20': galleryType === EGalleryTypes.carousel }" class="form-group">
                <label class="col-xs-9 control-label"> {{ "gallery_open_lightbox" | translate }} </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="clickable"></sp-switch>
                </div>
            </div>

            @if (galleryType === EGalleryTypes.carousel) {
                <div class="form-group">
                    <label class="col-xs-10 control-label"> {{ "gallery_autoplay" | translate }} </label>
                    <div class="col-xs-2 text-right">
                        <sp-switch [control]="autoplay"></sp-switch>
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
